import addListener from '../_addlistener.js';
import defs from '../../_core/defs.js';
import arrayAddHandler from './arrayaddhandler.js';
import objectSetHandler from './objectsethandler.js';
import arrayRemoveHandler from './arrayremovehandler.js';
import objectRemoveHandler from './objectremovehandler.js';
import changeHandler from './changehandler.js';
import matchesDelegation from './_matchesdelegation.js';
import forOwn from '../../_helpers/forown.js';
import { addOwner } from '../_owners.js';
import getProp from '../../_helpers/getprop.js';
import assign from '../../_helpers/assign.js';
// adds delegated event listener to an object by given path
export default function delegateListener(object, givenPath, name, callback, context, info) {
  var _path;
  if (info === void 0) {
    info = {};
  }
  // if typeof path is string and path is not empty string then split it
  // an empty string is kept: its length is 0, as for an empty array
  var path = typeof givenPath === 'string' && givenPath !== '' ? givenPath.split('.') : givenPath;
  if (!((_path = path) != null && _path.length)) {
    // if no path then add simple listener
    addListener(object, name, callback, context, info);
  } else {
    var _info$owner;
    // else do all magic
    var key = path[0];
    // who delegates through this object: the user (null) or a delegation from a parent
    var hopOwner = (_info$owner = info.owner) != null ? _info$owner : null;
    // what the next object along the path is kept by: this delegation
    info = assign({}, info, {
      owner: {
        object: object,
        path: path.join('.')
      }
    });
    path = path.slice(1);
    // needed for undelegation
    var pathStr = path.join('.');
    var delegatedData = {
      path: path,
      name: name,
      callback: callback,
      context: context,
      info: info,
      object: object
    };
    // internal events are added with { skipChecks: true }, so the same handler can serve many listeners;
    // a listener which is already delegated gets one more owner here
    var isDelegated = function isDelegated() {
      var found = false;
      for (var _len = arguments.length, eventNames = new Array(_len), _key = 0; _key < _len; _key++) {
        eventNames[_key] = arguments[_key];
      }
      for (var _i2 = 0; _i2 < eventNames.length; _i2++) {
        var eventName = eventNames[_i2];
        for (var _i4 = 0, _ref2 = (_defs$get$events$even = (_defs$get = defs.get(object)) == null ? void 0 : _defs$get.events[eventName]) != null ? _defs$get$events$even : []; _i4 < _ref2.length; _i4++) {
          var _defs$get$events$even, _defs$get;
          var event = _ref2[_i4];
          if (matchesDelegation(event, assign({
            pathStr: pathStr
          }, delegatedData), true)) {
            addOwner(event, hopOwner);
            found = true;
          }
        }
      }
      return found;
    };
    var owners = [hopOwner];
    if (key === '*') {
      // handling asterisk events
      if (object.isMatreshkaArray) {
        if (isDelegated('_asterisk:add', '_asterisk:remove')) {
          return;
        }
        // the event is triggered when something is added to an array
        addListener(object, '_asterisk:add', arrayAddHandler, null, {
          delegatedData: delegatedData,
          pathStr: pathStr,
          skipChecks: true,
          owners: owners
        });
        // the event is triggered when something is removed from an array
        addListener(object, '_asterisk:remove', arrayRemoveHandler, null, {
          delegatedData: delegatedData,
          pathStr: pathStr,
          skipChecks: true,
          owners: owners
        });
        // call handler manually to delegate listener for currently existing data props
        arrayAddHandler({
          // a Matreshka.Array is array-like
          added: object
        }, delegatedData);
      } else if (object.isMatreshkaObject) {
        if (isDelegated('_asterisk:set', '_asterisk:remove')) {
          return;
        }
        // a Matreshka.Object always has a definition with data keys
        var def = defs.get(object);
        // the event is triggered when data prop is changed
        addListener(object, '_asterisk:set', objectSetHandler, null, {
          delegatedData: delegatedData,
          pathStr: pathStr,
          skipChecks: true,
          owners: owners
        });
        // the event is triggered when data prop is removed
        addListener(object, '_asterisk:remove', objectRemoveHandler, null, {
          delegatedData: delegatedData,
          pathStr: pathStr,
          skipChecks: true,
          owners: owners
        });
        // delegate listener for currently existing data props
        forOwn(def.keys, function (_, defKey) {
          var item = object[defKey];
          if (item && typeof item === 'object') {
            delegateListener(item, path, name, callback, context, info);
          }
        });
      }
    } else {
      // handling non-asterisk delegated event
      var delegatedEventName = "_change:delegated:" + key;
      if (isDelegated(delegatedEventName)) {
        return;
      }
      // the event is triggered by "set"
      addListener(object, delegatedEventName, changeHandler, null, {
        delegatedData: delegatedData,
        pathStr: pathStr,
        skipChecks: true,
        owners: owners
      });
      // call handler manually
      changeHandler({
        value: getProp(object, key)
      }, delegatedData);
    }
  }
}